export default __webpack_public_path__ + "static/media/le_touquet8.4bff3273.jpg";